import { render, staticRenderFns } from "./CustomizeDetail.vue?vue&type=template&id=62a1008d&scoped=true"
import script from "./CustomizeDetail.vue?vue&type=script&lang=js"
export * from "./CustomizeDetail.vue?vue&type=script&lang=js"
import style0 from "./CustomizeDetail.vue?vue&type=style&index=0&id=62a1008d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a1008d",
  null
  
)

export default component.exports